import { bearerAuthOptions } from "./util";
import { apiUrl } from "../config";
import axios from "axios";

export function updateEmail(email) {
	return axios
		.post(`${apiUrl}/learner/editemail`, { email }, bearerAuthOptions)
		.then(r => r.data);
}

export function me() {
	return axios.get(`${apiUrl}/learner/me`, bearerAuthOptions).then(r => r.data);
}



// WEBPACK FOOTER //
// ./src/api/account.js